import Vue from 'vue';
import store from '@app/store';

export default class ModulesService extends Vue {
  hasModuleActivated(module: string) {
    // return true;
    const selectedTenant = store.getters['tenant/selectedTenant'];

    const field = module + '_activated';
    if (selectedTenant && selectedTenant[field]) {
      return true;
    }
    return false;
  }

  hasSomeModuleActivated(modules: []) {
    return modules.some(this.isActivatedModule);
  }

  isActivatedModule(module, index, array) {
    const selectedTenant = store.getters['tenant/selectedTenant'];
    const field = module + '_activated';
    if (selectedTenant && selectedTenant[field]) {
      return true;
    }
    return false;
  }
}
